import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import New from '@/components/screens/new/New';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IBooksPage } from '@/interfaces/booksPage.interface';

const NewPageDynamic: NextPage<IBooksPage> = ({ books }) => {
  useRedirectToFirstPage('/new/books/sorting/visited/');
  return <New books={books} sortingName="по просмотрам" sortingUrl={'sorting/visited'} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}satellite/books/news?last_books_per_days=30&page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}&sort_field=views_count&sort_reversed=true`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default NewPageDynamic;
